import { createRootRouteWithContext } from '@tanstack/react-router';

import { RootLayout } from 'components/RootLayout/RootLayout';

import type { RouterContext } from 'src/lib/routing/router-context';

/**
 * The generated root route — owns the whole route tree. File-based routes
 * added under `src/routes/` become fully typed children via the codegen
 * (`src/routeTree.gen.ts`); the legacy RouteObject shim tree is grafted on as
 * runtime-only children in `src/router.tsx`.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});
